<div
  class="flex flex-1 flex-col items-center justify-center text-center md:gap-10"
>
  <div class="mx-auto flex max-w-[500px] flex-col gap-4">
    <h2 class="text-primary-900">
      {{ "prestations.selectTransportCategoryTitle" | transloco }}
    </h2>
    <p class="text-paragraph-s-reg">
      {{ "prestations.selectTransportCategoryText" | transloco }}
    </p>
  </div>
  <app-category-selector
    [categoryList]="[
      {
        icon: 'plane',
        value: 'plane',
        label: 'categoryType.plane' | transloco,
        description: 'prestations.categoryDescription.plane' | transloco,
      },
      {
        icon: 'train',
        value: 'train',
        label: 'categoryType.train' | transloco,
        description: 'prestations.categoryDescription.train' | transloco,
      },
      {
        icon: 'car',
        value: 'car',
        label: 'categoryType.car' | transloco,
        description: 'prestations.categoryDescription.car' | transloco,
      },
      {
        icon: 'bike',
        value: 'twoWheels',
        label: 'categoryType.twoWheels' | transloco,
        description: 'prestations.categoryDescription.twoWheels' | transloco,
      },
      {
        icon: 'bus',
        value: 'bus',
        label: 'categoryType.bus' | transloco,
        description: 'prestations.categoryDescription.bus' | transloco,
      },
      {
        icon: 'ship',
        value: 'boat',
        label: 'categoryType.boat' | transloco,
        description: 'prestations.categoryDescription.boat' | transloco,
      },
      {
        icon: 'ship',
        value: 'cruise',
        label: 'categoryType.cruise' | transloco,
        description: 'prestations.categoryDescription.cruise' | transloco,
      },
      {
        icon: 'calculator',
        value: 'custom',
        label: 'categoryType.custom' | transloco,
      },
    ]"
    [(selectedValue)]="transportCategory"
    [shadow]="true"
  />
</div>
